import React, { useState } from "react";
import { motion, AnimatePresence } from "motion/react";
import { ReactComponent as CloseIcon } from "assets/icons/close.svg";
import { APP_CONFIG } from "constants/constants";

interface FloatingActionButtonProps {
    icon: React.ReactNode;
    onClick?: () => void;
    children?: React.ReactNode;
}

const FloatingActionButton: React.FC<FloatingActionButtonProps> = ({ icon, onClick, children }) => {

    const [isOpen , setIsOpen] = useState(false)

    const buttonClassNames = `
        fixed
        bottom-4
        right-4
        z-[50]
        lg:hidden
        flex
        flex-col
        items-end
        gap-y-2
    `;

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else {
            setIsOpen(!isOpen)
        }
    }

    return (
        <>
            {isOpen && (
                <div className="
                    fixed
                    top-0
                    left-0
                    right-0
                    bottom-0
                    z-[40]
                " onClick={() => setIsOpen(false)}></div>
            )}
            <div className={buttonClassNames}>
                <AnimatePresence>
                    {isOpen && React.Children.toArray(children).map((child, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1, transition: { duration: APP_CONFIG.MICRO_ANIMATION_DURATION, delay: (React.Children.count(children) * 0.03) - (index * 0.03) } }}
                            exit={{ opacity: 0, scale: 0.9, transition: { duration: APP_CONFIG.ULTRA_FAST_ANIMATION_DURATION } }}
                            onClick={() => setIsOpen(false)}
                        >
                            {child}
                        </motion.div>
                    ))}
                </AnimatePresence>
                <div
                    className={`
                        bg-customSecondary
                        text-white
                        rounded-full
                        flex
                        items-center
                        justify-center
                        p-4
                        w-fit
                        shadow-lg
                    `}
                    onClick={handleClick}
                >
                    {isOpen ? <CloseIcon /> : icon}
                </div>
            </div>
        </>
    );
};

export default FloatingActionButton;
